
  import { get } from 'lodash';
  import { mapGetters } from 'vuex';

  export default {
    computed: {
      ...mapGetters('providers', { provider: 'get' }),
      providerLogo () {
        return get(this, 'provider.logo', null);
      },
      seoContentBody () {
        return get(this, 'provider.seo_content.body', null);
      }
    }
  };
